import React, { useCallback, useEffect } from 'react'

import toast from 'react-hot-toast'
import { GrClose } from 'react-icons/gr'

import Classes from './Classes'
import DateRow from './DateRow'
import PriceRow from './PriceRow'
import SelectRows from './SelectRows'
import { Button } from '../..'
import {
  useCupons,
  useModal,
  useProfessors,
  useStudents,
} from '../../../context'
import { useBonus } from '../../../hooks/useBonusState'
import { NewCupon } from '../../../types'

import { ModalBackground, Modal, TitleRow, ButtonRow } from './styles'

const BonoModal = ({ info }: { info?: NewCupon | null | undefined }) => {
  const { studentsList, activeStudent } = useStudents()
  const { createCupon } = useCupons()
  const { professorsList } = useProfessors()
  const { modalStatus, setModalStatus } = useModal()

  const {
    newCupon,
    updateCupon,
    updateInput,
    handleStudentChange,
    updateStudent,
    updateDate,
    studentWithActiveCupon,
    resetCupon,
    isButtonDisable,
    isFormValid,
  } = useBonus()

  const handleClose = useCallback(() => {
    setModalStatus(!modalStatus)
    resetCupon()
  }, [modalStatus, setModalStatus])

  const handleSave = useCallback(async () => {
    if (!isFormValid) return

    try {
      await createCupon(newCupon)
      toast.success(info ? 'Bono actualizado' : 'Bono creado')
      resetCupon()
      handleClose()
    } catch (e) {
      console.error(e)
      toast.error('Hubo un error al guardar el bono.')
    }
  }, [isFormValid, createCupon, newCupon, resetCupon, handleClose, info])

  useEffect(() => {
    if (activeStudent) {
      updateStudent(activeStudent)
    }
  }, [])

  return (
    <ModalBackground>
      <Modal>
        <TitleRow>
          <div className="title">{info ? 'Editar Bono' : 'Agregar Bono'}</div>
          <div className="close" onClick={handleClose}>
            <GrClose />
          </div>
        </TitleRow>

        {studentsList && (
          <SelectRows
            value={newCupon.idStudent}
            list={studentsList}
            id="idStudent"
            updateFn={handleStudentChange}
          />
        )}
        <Classes
          amountOfClasses={newCupon.amountOfClasses}
          handleMenuChange={updateCupon}
          studentHasActiveBonus={studentWithActiveCupon}
        />

        {newCupon.amountOfClasses === 1 && professorsList && (
          <SelectRows
            value={newCupon.teacher}
            list={professorsList}
            id="teacher"
            updateFn={updateInput}
          />
        )}

        <PriceRow
          price={newCupon.price}
          hasPayed={newCupon.payed}
          handleInputChange={updateInput}
          handleMenuChange={updateCupon}
        />

        <DateRow newCupon={newCupon} updateDate={updateDate} />
        <ButtonRow>
          <Button
            disabled={isButtonDisable}
            onClick={handleSave}
            label="Guardar"
            className="dark-grey"
            fontSize={14}
          />
        </ButtonRow>
      </Modal>
    </ModalBackground>
  )
}

export default BonoModal
